import {APP_SUBSCRIBE_TO_NEWSLETTER_SUCCESS} from "../../actions/App/AppNewsletter";
import update from "immutability-helper";

const initialState = {
	accepted: null,
};

export const AppSubscribeToNewsletterReducer = (state = initialState, action) => {
	switch (action.type) {
		case APP_SUBSCRIBE_TO_NEWSLETTER_SUCCESS:
			return update(state, {
					$set: action.payload,
			});
		default:
			return state;
	}
};
